import useAuthStore from '../stores/authStore';

/**
 * Returns true if the current user holds the `admin` or `super_admin`
 * role. Used to gate admin-only UI surfaces (debug toggles, internal
 * trace drawers, etc.). PRP-009.
 *
 * The roles set is populated by App.tsx after auth via
 * `BackendAPI.adminMe()`. Until that resolves, this returns false —
 * conservative default so non-admin users never see a flash of admin UI.
 */
export function useIsAdmin(): boolean {
  const roles = useAuthStore((s) => s.roles);
  return roles.includes('admin') || roles.includes('super_admin');
}
